<button
  type="button"
  class="delivery-service-card"
  [class.delivery-service-card--selected]="selected()"
  [attr.aria-pressed]="selected()"
  [attr.data-testid]="'delivery-service-card-' + offering().productCode"
  (click)="onSelect()"
>
  @if (fastest()) {
    <div class="delivery-service-card__badge" data-testid="badge-fastest">
      {{ 'createShipment.serviceStep.deliveryService.badges.fastest' | translate }}
    </div>
  }
  @if (mostEconomical()) {
    <div class="delivery-service-card__badge" data-testid="badge-most-economical">
      {{ 'createShipment.serviceStep.deliveryService.badges.mostEconomical' | translate }}
    </div>
  }

  <div class="delivery-service-card__body">
    <div class="delivery-service-card__details">
      <puro-typography component="h3" variant="h5" class="delivery-service-card__name">
        {{ serviceDisplayName() }}
      </puro-typography>
      <puro-typography component="p" variant="body2" class="delivery-service-card__commitment">
        {{ commitmentLabel() }}
      </puro-typography>
    </div>
    <div class="delivery-service-card__cost">
      <puro-typography component="span" variant="caption" class="delivery-service-card__cost-label">
        {{ 'createShipment.serviceStep.deliveryService.estimatedCostLabel' | translate }}
      </puro-typography>
      <puro-typography
        component="span"
        variant="h5"
        color="midBlue"
        class="delivery-service-card__cost-value"
      >
        {{ formatCurrencyAmount(offering().pricing.totalPrice) }}
      </puro-typography>
    </div>
  </div>
</button>
